import React from 'react';
export function AboutSection() {
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-17" data-mp="3nndguzcdi347">
      <div className="max-w-3xl mx-auto text-center" data-id="element-18" data-mp="2lbn699ddxxkj">
        <h2 className="text-3xl font-black text-brand-text mb-8" data-id="element-19" data-mp="2la3qrkzjzqjt">
          A propósito de Pilates Listo 360
        </h2>
        <div className="space-y-5 text-lg text-brand-gray leading-relaxed" data-id="element-20" data-mp="2be0o8e0shpwc">
          <p data-id="element-21" data-mp="2bg3e8y1xzj12">
            Pilates Listo 360 nació de una pregunta simple: por qué una
            instructora que sabe muchísimo de Pilates tiene que pasar el domingo
            entero armando clases. El problema nunca fue el conocimiento. Fue el
            tiempo.
          </p>
          <p data-id="element-22" data-mp="1xn43f9d3uczu">
            Así que armamos lo que a nosotros nos hubiera servido tener: seis
            manuales con el repertorio completo, de iniciación a avanzado, con
            cada ejercicio ilustrado, sus repeticiones, sus errores frecuentes,
            la corrección exacta y hasta la consigna que decís en voz alta. Más
            de cien clases ya armadas con minutaje. Y todo listo para imprimir y
            llevar a la sala.
          </p>
          <p data-id="element-23" data-mp="xjb54gqfr5rx">
            No es una formación. No te va a enseñar Pilates: eso ya lo sabés. Es
            el trabajo que ibas a hacer vos los próximos doce domingos, ya
            hecho.
          </p>
        </div>
      </div>
    </section>;
}